import JsonLd from '@/components/base/JsonLd';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SEOContent from './components/SEOContent';
import ArticleCards from './components/ArticleCards';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoosheet.homes';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spreadsheet',
  url: `${siteUrl}/`,
  description: 'The ultimate Sugargoo shopping resource hub — organized product spreadsheets, reviews, shipping guides, coupons, and expert tips for international shoppers.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Sugargoo Spreadsheet',
    url: `${siteUrl}/`,
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleCards />
        <SEOContent />
      </main>
      <Footer />
    </div>
  );
}